import { render, staticRenderFns } from "./TermsBox.vue?vue&type=template&id=6f2cfc0a&scoped=true"
import script from "./TermsBox.vue?vue&type=script&lang=js"
export * from "./TermsBox.vue?vue&type=script&lang=js"
import style0 from "./TermsBox.vue?vue&type=style&index=0&id=6f2cfc0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2cfc0a",
  null
  
)

export default component.exports